module.exports = __webpack_public_path__ + "static/media/logs.63a3847f.jpg";